import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useSession } from "@/services/auth0/session";
import { CreateDepotSchema } from "@/api.schemas";
import { Depot } from "@/api.types";

// Get all depots
export function useDepots() {
  const { token } = useSession();

  return useQuery<Depot[]>({
    queryKey: ["depots"],
    queryFn: async () => {
      const { data } = await axios.get<Depot[]>(
        `${import.meta.env.VITE_API_URL}/api/v1/depots`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return data;
    },
    enabled: !!token,
  });
}

// Create depot mutation
export function useCreateDepot() {
  const { token } = useSession();
  const queryClient = useQueryClient();

  return useMutation<Depot, Error, CreateDepotSchema>({
    mutationFn: async (values) => {
      const { data } = await axios.post<Depot>(
        `${import.meta.env.VITE_API_URL}/api/v1/depots/create`,
        values,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["depots"] });
    },
  });
}
